module.exports = __webpack_public_path__ + "img/chengxinmaiIcon.b2f06a72.png";